import { HTTP_STATUS } from 'cpool-constants';

export const isBadRequestError = (error: unknown): boolean =>
    typeof error === 'object' && error !== null && 'status' in error && error.status === HTTP_STATUS.BAD_REQUEST;
